import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function usePageTracking() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.analytics?.page(undefined, pathname.substring(1))
  }, [pathname])
}
